import { render, staticRenderFns } from "./DataTableHeaderColumn.vue?vue&type=template&id=0f7050d0"
import script from "./DataTableHeaderColumn.vue?vue&type=script&lang=js"
export * from "./DataTableHeaderColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports